import React, { useEffect } from "react";
import back from "../../Asset/product/back.png";
import { useLocation } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Term = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location?.pathname]);

    useEffect(() => {
      AOS.init();
  }, [])
  return (
    <div
     className="w-full bg-Background3 pl:5 pr-5 md:pl-20 md:pr-20 md:pt-20 md:pb-44 overflow-x-hidden"
      style={{ backgroundImage: `url(${back})` }}
    >
      <div className="bg-white/50 p-4 rounded-3xl">
        <div className="w-full my-10" data-aos="fade-right">
          <span className="text-textColor font-semibold text-3xl">
            Terms and Conditions
          </span>
        </div>
        <div className="w-full" >
          <div className="my-3" data-aos="fade-left">
            <span className="text-textColor text-2xl font-semibold ">
              Acceptance of Terms
            </span>
            <p className="text-textColor">
              By accessing or using the Sehatful website (www.sehatful.com) and
              mobile application ("Service"), you agree to be bound by these
              Terms and Conditions ("Terms"). If you do not agree to all of
              these Terms, do not use our Service.
            </p>
          </div>
          <div className="my-3" data-aos="fade-right">
            <span className="text-textColor text-2xl font-semibold mt-2">
              Service Description
            </span>
            <p className="text-textColor">
              Sehatful provides an e-commerce platform for purchasing organic
              food products, supplements, and related items through our website
              and mobile application. We reserve the right to modify or
              discontinue the Service at any time without notice.
            </p>
          </div>
          <div className="my-3 flex flex-col" data-aos="fade-left">
            <span className="text-textColor text-2xl font-semibold mt-4">
              Account Registration
            </span>
            <span className="text-textColor text-lg font-semibold mt-4">
              Eligibility
            </span>
            <p className="text-textColor">
              To use certain features of the Service, you must register for an
              account. You must be at least 18 years old or the age of majority
              in your jurisdiction to create an account.
            </p>
            <span className="text-textColor text-lg font-semibold mt-4">
              Account Security
            </span>
            <p className="text-textColor">
              You are responsible for maintaining the confidentiality of your
              account credentials and for all activities that occur under your
              account. Notify us immediately of any unauthorized use of your
              account.
            </p>
            <span className="text-textColor text-lg font-semibold mt-4">
              Account Termination
            </span>
            <p className="text-textColor">
              We reserve the right to suspend or terminate accounts that violate
              these Terms or for any other reason at our sole discretion.
            </p>
          </div>
          <div className="my-3 flex flex-col" data-aos="fade-right">
            <span className="text-textColor text-2xl font-semibold">
              Purchases and Payments
            </span>
            <span className="text-textColor text-lg font-semibold">
              Product Information
            </span>
            <p className="text-textColor">
              We strive for accuracy in product descriptions, images, and
              pricing but do not warrant they are complete, reliable, current,
              or error-free. All products are subject to availability.
            </p>
            <span className="text-textColor text-lg font-semibold">
              Pricing
            </span>
            <p className="text-textColor">
              All prices are in [currency] and exclude applicable taxes and
              shipping fees, which will be calculated at checkout. We reserve
              the right to change prices at any time.
            </p>
            <span className="text-textColor text-lg font-semibold">
              Payment Methods
            </span>
            <p className="text-textColor">
              We accept various payment methods as indicated at checkout. You
              authorize us to charge your selected payment method for the total
              amount of your order.
            </p>
            <span className="text-textColor text-lg font-semibold">
              Order Acceptance
            </span>
            <p className="text-textColor">
              Your order constitutes an offer to purchase. We reserve the right
              to refuse or cancel any order for any reason, including
              limitations on quantities available for purchase.
            </p>
          </div>
          <div className="my-3" data-aos="fade-left">
            <span className="text-textColor text-xl font-semibold">
              Shipping and Delivery
            </span>
            <span className="text-textColor text-lg font-semibold">
              Shipping Policy
            </span>
            <p className="text-textColor">
              We ship to the locations specified on our website. Delivery times
              are estimates only. We are not responsible for delays caused by
              shipping carriers or unforeseen circumstances.
            </p>
            <span className="text-textColor text-lg font-semibold">
              Risk of Loss
            </span>

            <p className="text-textColor">
              Title and risk of loss pass to you upon our delivery of products
              to the carrier. You are responsible for filing any claims with
              carriers for damaged or lost shipments.
            </p>
            <span className="text-textColor text-lg font-semibold">
              International Orders
            </span>
            <p className="text-textColor">
              International customers are responsible for any customs duties,
              taxes, or fees imposed by their country. We cannot guarantee that
              international orders will clear customs.
            </p>
          </div>
          <div className="my-3" data-aos="fade-right">
            <span className="text-textColor text-2xl font-semibold">
              Returns and Refunds
            </span>
            <span className="text-textColor text-lg font-semibold">
              Return Policy
            </span>
            <p className="text-textColor">
              We accept returns of unopened, unused products in their original
              packaging within [X] days of delivery. Perishable goods cannot be
              returned.
            </p>
            <span className="text-textColor text-lg font-semibold">
              Refund Process
            </span>
            <p className="text-textColor">
              Refunds will be issued to the original payment method within [X]
              business days after we receive and inspect the returned item.
              Shipping costs are non-refundable.
            </p>
            <span className="text-textColor text-lg font-semibold">
              Damaged or Defective Items
            </span>
            <p className="text-textColor">
              Contact us within [X] days of receipt for damaged or defective
              items. We may require photographic evidence and may replace the
              item or issue a refund at our discretion.
            </p>
          </div>
          <div className="my-3 flex flex-col" data-aos="fade-left">
            <span className="text-textColor text-2xl font-semibold">
              Mobile App Specific Terms
            </span>
            <span className="text-textColor text-lg font-semibold">
              App License
            </span>
            <p className="text-textColor">
              We grant you a limited, non-exclusive, non-transferable license to
              use the Sehatful mobile application for personal, non-commercial
              use.
            </p>
            <span className="text-textColor text-lg font-semibold">
              App Updates
            </span>
            <p className="text-textColor">
              We may automatically update the mobile app to provide enhancements
              or fixes. Some updates may require your acceptance of revised
              Terms.
            </p>
            <span className="text-textColor text-lg font-semibold">
              App Stores
            </span>
            <p className="text-textColor">
              Your download and use of the app may be subject to additional
              terms of the app store (Google Play, Apple App Store, etc.).
            </p>
          </div>
          <div className="my-3" data-aos="fade-right">
            <span className="text-textColor text-2xl font-semibold">
              User Conduct
            </span>

            <p className="text-textColor">You agree not to:</p>
            <p className="text-textColor">
              {" "}
              &bull; Use the Service for any illegal purpose or in violation of
              any laws
            </p>
            <p className="text-textColor">
              {" "}
              &bull; Violate or encourage others to violate these Terms
            </p>
            <p className="text-textColor">
              {" "}
              &bull; Interfere with the operation of the Service or others'
              enjoyment of it
            </p>
            <p className="text-textColor">
              {" "}
              &bull; Attempt to gain unauthorized access to our systems or other
              accounts
            </p>
            <p className="text-textColor">
              {" "}
              &bull; Upload viruses or malicious code
            </p>
            <p className="text-textColor">
              {" "}
              &bull; Engage in fraudulent, abusive, or misleading conduct
            </p>
          </div>
          <div className="my-3" data-aos="fade-left">
            <span className="text-textColor text-2xl font-semibold">
              Intellectual Property
            </span>
            <p className="text-textColor">
              All content on the Service (text, graphics, logos, software) is
              our property or our licensors' and is protected by copyright and
              other intellectual property laws. You may not use our trademarks
              without our prior written permission.
            </p>
          </div>
          <div className="my-3" data-aos="fade-right">
            <span className="text-textColor text-2xl font-semibold">
              Disclaimer of Warranties
            </span>
            <p className="text-textColor">
              THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND,
              EITHER EXPRESS OR IMPLIED. WE DISCLAIM ALL WARRANTIES INCLUDING
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
              NON-INFRINGEMENT.
            </p>
            <p className="text-textColor">
              We do not warrant that the Service will be uninterrupted, secure,
              or error-free, or that defects will be corrected.
            </p>
          </div>
          <div className="my-3" data-aos="fade-left">
            <span className="text-textColor text-2xl font-semibold">
              Limitation of Liability
            </span>
            <p className="text-textColor">
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR
              ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE
              DAMAGES ARISING FROM YOUR USE OF THE SERVICE. OUR TOTAL LIABILITY
              FOR ANY CLAIMS RELATED TO THE SERVICE SHALL NOT EXCEED THE AMOUNT
              YOU PAID US IN THE LAST 12 MONTHS.
            </p>
         
          
           
          </div>
          <div className="my-3" data-aos="fade-right">
            <span className="text-textColor text-2xl font-semibold">
            Indemnification
            </span>
            <p className="text-textColor">
            You agree to indemnify and hold harmless Sehatful and its affiliates from any claims, damages, or expenses arising from your violation of these Terms or your use of the Service.
            </p>
          
          </div>
          <div className="my-3" data-aos="fade-left">
            <span className="text-textColor text-2xl font-semibold">
            Termination
            </span>
            <p className="text-textColor">
            We may terminate or suspend your access to the Service immediately, without prior notice, for any reason, including if you breach these Terms.
            </p>
          
          </div>
          <div className="my-3" data-aos="fade-right">
            <span className="text-textColor text-2xl font-semibold">
            Governing Law
            </span>
            <p className="text-textColor">
            These Terms shall be governed by the laws of [Your Jurisdiction], without regard to its conflict of law provisions.
            </p>
          
          </div>
          <div className="my-3" data-aos="fade-left">
            <span className="text-textColor text-2xl font-semibold">
            Dispute Resolution
            </span>
            <p className="text-textColor">
            Any disputes shall first be attempted to be resolved through good faith negotiations. If unresolved, disputes shall be submitted to binding arbitration in [Your Jurisdiction] under the rules of [Arbitration Organization].
            </p>
          
          </div>
          <div className="my-3" data-aos="fade-right">
            <span className="text-textColor text-2xl font-semibold">
            Changes to Terms
            </span>
            <p className="text-textColor">
            We may modify these Terms at any time. We will notify you of significant changes through the Service or by email. Your continued use constitutes acceptance of the revised Terms.
            </p>
          
          </div>
          <div className="my-3" data-aos="fade-left">
            <span className="text-textColor text-2xl font-semibold">
            Miscellaneous
            </span>
            <span className="text-textColor text-lg font-semibold">
            Entire Agreement
            </span>
            <p className="text-textColor">
            These Terms constitute the entire agreement between you and Sehatful regarding the Service.
            </p>
            <span className="text-textColor text-lg font-semibold">
            Severability
            </span>
            <p className="text-textColor">
            If any provision of these Terms is found invalid or unenforceable, the remaining provisions will remain in full effect.
            </p>
            <span className="text-textColor text-lg font-semibold">
            Waiver
            </span>
            <p className="text-textColor">
            Our failure to enforce any right or provision will not be considered a waiver of those rights.
            </p>
          </div>
          <div className="md:my-3 my-12" data-aos="fade-right">
            <span className="text-textColor text-2xl font-semibold">
              Contact Us
            </span>
           
            <p className="text-textColor font-semibold">SEHATFUL SOLUTIONS PRIVATE LIMITED</p>
            <p className="text-textColor">Email: privacy@sehatful.com</p>
            <p className="text-textColor">Phone: +91 7411672999</p>
            <p className="text-textColor">
              Address: Site Number 27, Next to Sobha Sentosa , Balagere Village, Kundalahalli, Bangalore North, Bangalore- 560037, Karnataka
            </p>
            <p className="text-textColor">
              © 2025 Sehatful. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Term;
